/**
 * 문자 인증
 */
import Util from '../Common/Util';
export default class SmsAuth {
    constructor() {
        this.type = null;
        this.isSendSMS = 0;
        this.authTimer = null;
    }

    /**
     * 비번찾기 모달 초기화
     * @param type 구분 pass(비번찾기)
     */
    start(type){
        this.type = type;
        this.open();
        this.initHandler();
    }

    /**
     * SMS 인증창 띄우기
     */
    open() {
        const self = this;
        const html = `
<div class="sms-auth">
    <div class="sms-auth__row">
        <input class="sms-auth__inp" type="tel" inputmode="numeric" id="mem_phone" placeholder="전화번호 입력">
        <button type="button" class="sms-auth__btn" id="send-sms"><span id="sms-send-label">인증하기</span></button>
    </div>

    <!-- 인증번호 인풋 — 코드를 보낸 뒤에만 보여준다 -->
    <div id="after-send-area" hidden>
        <div class="sms-auth__row sms-auth__row--code">
            <input class="sms-auth__inp" type="tel" inputmode="numeric" maxlength="4" id="code" placeholder="인증코드 입력">
            <button type="button" class="sms-auth__btn" id="auth-sms">확인</button>
        </div>
        <div class="sms-auth__timer" id="timer" hidden></div>
        <p class="sms-auth__help">인증에 실패하셨나요? <a href="tel:1600-0421">문의하기</a></p>
    </div>
</div>
        `;
        // 제목은 모달 헤더가 든다 (구 본문 첫 줄의 <h4>SMS 인증</h4>)
        this.modal = $j.Ui.Modal.open({ mode: 'center', variant: 'mobile', title: 'SMS 인증', html });

        $('#sms-send-label').html('전송');
        $('#timer').prop('hidden', true);
        $('#after-send-area').prop('hidden', true);
        $('#mem_phone').val('');
        $('#code').val('');

        this.isSendSMS=0;

    }

    /**
     * 인증창 닫기
     */
    close(){
        this.clearTimerCountdown();
        this.modal?.close();
    }

    /**
     * 이벤트 초기화
     */
    initHandler(){
        const self = this;
        // 카운트다운은 코드를 보낸 뒤에 시작한다 (여기서 돌리면 대상 id 가 없어 헛돈다)
        this.clearTimerCountdown();

        $j.Common.Form.registerPhoneHandler('mem_phone');

        // 전송 버튼 클릭
        $('#send-sms').on('click', function(){
            self.isSendSMS=1;
            const mem_phone = $('#mem_phone').val();
            $.ajax({
                url: '/m/ajax/member/sms/auth/send',
                type: 'POST',
                data : {
                    phone: mem_phone,
                    type: self.type,
                },
                success: function(data) {
                    // 실패했는데 '코드를 확인하세요' 를 이어 띄우면, 못 받은 코드를 기다리게 된다
                    if(!data || !data.result) {
                        self.isSendSMS=0;
                        Util.swalert((data && data.message) || '인증코드를 보내지 못했어요.');
                        return;
                    }
                    self.isSendSMS=2;
                    Util.swalert('카카오 알림톡 또는 문자로 발송된 4자리의 인증코드를 확인해주세요.', function(){
                        $('#sms-send-label').html('재전송');
                        $('#timer').prop('hidden', false);
                        $('#after-send-area').prop('hidden', false);
                        $('#code').trigger('focus');
                        self.showTimerCountdown('timer');
                    });
                },
                error: function() {
                    self.isSendSMS=0;
                    Util.swalert('인증코드를 보내는 중 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.');
                },
            });
        });
        // 확인 버튼 클릭
        $('#auth-sms').on('click', function(){
            if( self.isSendSMS!=2){
                Util.swalert('전화번호 입력후 전송버튼을 먼저 눌러주세요');
                return;
            }
            const code=$('#code').val();
            $.ajax({
                url: '/m/ajax/member/sms/auth/recv',
                type: 'POST',
                data : {code, type: self.type},
                success: function(response) {
                    $j.Common.EventBus.trigger('sms:auth', response);
                },
                error: function() {
                    Util.swalert('인증 확인 중 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.');
                },
            });
        });
    }


    /**
     * SMS 전송후 카운트 다운
     * @param id
     */
    showTimerCountdown(id){
        this.clearTimerCountdown();

        // Add 5 minutes to the current time
        const targetDate = dayjs().add(5, 'minute');
        // console.log(targetDate);

        // Calculate the initial time difference
        let timeDiff = targetDate.diff(dayjs(), 'second');

        // Update the timer every second
        const self = this;
        this.authTimer = setInterval(function() {
            // console.log(timeDiff);
            // Update the time difference
            timeDiff--;

            // Check if the timer has reached zero
            if (timeDiff <= 0) {
                self.clearTimerCountdown();
                $('#'+id).html('시간초과 — 인증번호를 다시 받아주세요');
                self.isSendSMS = 0;
                return;
            }

            // Calculate the remaining minutes and seconds
            const minutes = dayjs(timeDiff*1000, 'second').format('mm');
            const seconds = dayjs(timeDiff*1000, 'second').format('ss');

            // Update the timer display
            $(`#${id}`).html(`${minutes}:${seconds}`);
        }, 1000);
    }
    clearTimerCountdown() {
        if(this.authTimer) clearInterval(this.authTimer);
        this.authTimer = null;
    }
}